import React from "react";

import Step from "components/MainApp/atoms/Wizard/Step";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import Icon from "../../../../../../components/MainApp/atoms/Icon/icon";

import ItemTags from "components/MainApp/organisms/OrdersV3/Item-Tags";
import LocationSummary from "components/MainApp/organisms/OrdersV3/LocationSummary";
import RoundedButton from "components/MainApp/atoms/RoundedButton";

import styles from "./LocateMovementItems.module.scss";
import i18n from "i18n";

export const LocateMovementItems = ({
  itemsLocateds,
  itemsNoLocateds,
  handleDelete,
  handleSelect,
  allSelecteds,
  handleSelectAll,
  addLocation,
  handleSubmit,
  goBack
}) => {
  const stepContent = (
    <div className={styles["reception-order-step-three-content"]}>

      <div className={styles["check-all"]}>
        <div className={styles["all-selector"]} onClick={() => handleSelectAll()}>
          <Checkbox checked={allSelecteds} />
        </div>
        {i18n.t("all.products")}
      </div>
      <div className={styles["load-movement-items-list"]}>
        {itemsNoLocateds &&
          itemsNoLocateds.map((item) => {
            return (
              <ItemTags
                key={item.sku}
                item={item}
                quantity={item.tags.length}
                expected={item.expectedUnits}
                handleSelect={handleSelect}
              />
            );
          })}
      </div>


    </div>
  );
  return (
    <div className={styles["reception-order-step-three-outer"]}>
      <div className={styles["reception-order-step-three-container"]}>
      <div className={styles["locate-movement-items-title-wrapper"]} onClick={goBack}>
          <div className={styles["locate-movement-items-title-icon"]}>
            {" "}
            <Icon name="chevron" width={14} height={14} fill={"#62D862"} />
          </div>
          <h1 className={styles["locate-movement-items-title"]}>
            {i18n.t("locate.products")}
          </h1>
        </div>
        {itemsLocateds &&
          itemsLocateds.map((item) => {
            return (
              <div
                key={item.code}
                className={styles["reception-order-step-three-location"]}
              >
                <LocationSummary item={item} handleDelete={handleDelete} />
              </div>
            );
          })}

        {itemsNoLocateds.length !== 0 && (
          <Step
            title={i18n.t("select.products.and.location")}
            content={stepContent}
          ></Step>
        )}
      </div>
      <div className={`${styles["locate-movement-items-button"]} ${styles["last"]}`}>
        <div>
          {itemsNoLocateds.length !== 0 && (
            <RoundedButton
              legend={i18n.t("add.location").toUpperCase()}
              state="enabled"
              handleClick={addLocation}
            ></RoundedButton>
          )}
          {itemsNoLocateds.length === 0 && (
            <RoundedButton
              legend={i18n.t("finish.order").toUpperCase()}
              state="enabled"
              handleClick={handleSubmit}
            ></RoundedButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default LocateMovementItems;
